












































import { Component, Prop, Ref, Vue } from 'vue-property-decorator'

@Component({ name: 'RangeSlider' })
export default class RangeSlider extends Vue {
  @Prop({
    required: false,
    default: 10
  })
  rangeLimit!: number

  @Prop({
    required: false,
    default: false
  })
  isShownTooltip!: boolean

  @Prop({
    required: false,
    default: true
  })
  withNumber!: boolean

  @Prop({
    required: false,
    default: 1
  })
  stepForNumber!: number

  @Prop({
    required: false,
    default: 1
  })
  min!: number

  inputRange = 1
  generatedNumber: string | null = null

  @Ref()
  rangeSlider!: HTMLInputElement

  created (): void {
    this.generatedNumber = Math.random().toString(36).substring(7)
    this.inputRange = this.min
  }

  mounted () {
    this.rangeSlider.max = String(this.rangeLimit)
  }

  changeValueByNumber (selectedValue: number): void {
    this.rangeSlider.value = String(selectedValue)
    this.recalculateRangeStyles()
    this.inputRange = selectedValue

    this.$emit('change-value', this.inputRange)
  }

  changedValue (event: Event) {
    this.recalculateRangeStyles()
    const input = event.target as HTMLInputElement

    this.$emit('change-value', input.value)
  }

  recalculateRangeStyles (): void {
    const { value, min, max } = this.rangeSlider
    const dark = '#0085cd'
    const light = '#bdddff'
    const percentage: number = (Number(value) - Number(min)) / (Number(max) - Number(min)) * 100
    const direction = this.$i18n.locale === 'ar' ? 'left' : 'right'
    this.rangeSlider.style.background = `linear-gradient(to ${direction}, ${dark} 0%, ${dark} ${percentage}%, ${light} ${percentage}%, ${light} 100%)`
  }

  reset (): void {
    this.inputRange = 1
    this.rangeSlider.value = '1'
    this.recalculateRangeStyles()
  }

  get sliderId (): string {
    return `slider-${this.generatedNumber}`
  }

  get tooltipTextValue (): string {
    return (this.inputRange / this.stepForNumber).toFixed(1)
  }
}
